"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileApps = void 0;
var _mui = require("@ori-ui/mui");
var _environment = require("@ori/environment");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _MobileAppIcon = require("./components/MobileAppIcon");
var _SuperApp = require("./components/SuperApp");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const MobileApps = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    mobileApps,
    ourApps
  } = (0, _hooks.useFooter)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  if (!ourApps || !mobileApps) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.MOBILE_APPS),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "h5",
      component: "p",
      children: mobileApps.pageHeader?.title
    }), tenant === 'cn' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icons, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icon, {
        "data-testid": getTestId(_constants.APP_ICON),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SuperApp.SuperApp, {})
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icons, {
        children: mobileApps.mobileAppCollection.map((app, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Icon, {
          "data-testid": getTestId(_constants.APP_ICON),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MobileAppIcon.MobileAppIcon, {
            title: app.title ?? '',
            titleImage: app.titleImage ?? ''
          })
        }, app.title ?? index))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Link, {
        textTransform: "uppercase",
        fontWeight: "bold",
        color: "textPrimary",
        href: ourApps.url ?? '#',
        align: "center",
        children: ourApps.title ?? ''
      })]
    })]
  });
};
exports.MobileApps = MobileApps;
